import { buildLovTypesQuery } from './lov-query'
import {
  normalizeLovBatchResponse,
  normalizeLovResponse,
} from './normalize'

import type { LovBatchFetchFn, LovFetchFn } from './types'

export const DEFAULT_LOV_BATCH_URL = '/system/lov/getLov'

/** 默认 GET /system/lov/getLov?lovTypes=a&lovTypes=b */
export const DEFAULT_LOV_LIST_URL = '/system/lov/getLovList'
export const defaultFetchLovBatch: LovBatchFetchFn = async (lovTypes) => {
  if (!lovTypes.length) {
    return {}
  }
  const query = buildLovTypesQuery(lovTypes)
  const res = await fetch(`${DEFAULT_LOV_BATCH_URL}?${query}`)
  if (!res.ok) {
    throw new Error(`LOV batch request failed: ${res.status}`)
  }
  const json = await res.json()
  return normalizeLovBatchResponse(json)
}

/** 单类型：复用批量接口 */
export const defaultFetchLov: LovFetchFn = async (lovType, params) => {
  if (params && Object.keys(params).length) {
    const search = new URLSearchParams()
    search.set('type', lovType)
    for (const [key, val] of Object.entries(params)) {
      if (val != null && val !== '') {
        search.set(key, String(val))
      }
    }
    const res = await fetch(`/lov?${search.toString()}`)
    if (!res.ok) {
      throw new Error(`LOV request failed: ${res.status}`)
    }
    const json = await res.json()
    return normalizeLovResponse(json)
  }

  const batch = await defaultFetchLovBatch([lovType])
  return batch[lovType] ?? []
}
